import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


export default function InfoPopup(props: any) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const handleClickOpen = () => {
        props.setOpen(true);
      };
    
      const handleClose = () => {
        props.setOpen(false);
      };

    // const descriptionElementRef = React.useRef<HTMLElement>(null);
    // React.useEffect(() => {
    //     if (props.open) {
    //         const { current: descriptionElement } = descriptionElementRef;
    //         if (descriptionElement !== null) {
    //             descriptionElement.focus();
    //         }
    //     }
    // }, [props.open]);

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={props.open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    Schadflächen (2016 - 2020)
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    Die Daten des Waldbiomasse-Trends 2016-2020 wurden mittels verschiedener Schwellwerte für Laub- und Nadelwälder klassifiziert und die Flächen pro Bundesland ermittelt.

Hierbei handelt es sich um die Gebiete mit völligem Verlust der Waldbestände. Die Waldflächen mit Teilschäden sind wesentlich größer als die Verlustflächen.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    
                    <Button sx={{mr:"24px"}} onClick={handleClose} autoFocus>
                        Zurück
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}